// Currency context bridge — display currency (EUR/CZK) resolved server-side by host.
// Exposes `this.$currency` in every Vue component. window.__CURRENCY__ is injected
// by the `partials.currency-bootstrap` Blade partial before any Vue entry loads.
export function installCurrency(Vue) {
    const cur = window.__CURRENCY__ || { code: 'EUR', symbol: '€', rates: { EUR: 1 }, symbols: { EUR: '€' } };

    Vue.prototype.$currency = {
        code: cur.code,
        symbol: cur.symbol,
        rates: cur.rates,
        symbols: cur.symbols,
        isCzech() {
            return this.code === 'CZK';
        },
        convert(amount, from, to) {
            to = to || this.code;
            const rf = this.rates[from] || 1;
            const rt = this.rates[to] || 1;
            return (Number(amount) || 0) / rf * rt;
        },
        format(amount) {
            const a = Number(amount) || 0;
            if (this.code === 'CZK') {
                const n = Math.round(a).toLocaleString('sk-SK').replace(/ /g, ' ');
                return `${n} ${this.symbol}`;
            }
            const n = a.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ');
            return `${n} ${this.symbol}`;
        },
    };
}
